// extracted by mini-css-extract-plugin
module.exports = {"head":"Head-module--head--C4jAe","headCircle":"Head-module--headCircle--3BoS8","headLogo":"Head-module--headLogo--2EPmt"};